import type { JSX } from 'react';

import { useTestingCenterContext } from './TestingCenterLayout';
import RunsSection from './runs/RunsSection';

const TestingCenterRunsPage = (): JSX.Element => {
  const { masterProject, subProjects } = useTestingCenterContext();

  return <RunsSection key={masterProject.id} masterProject={masterProject} subProjects={subProjects} />;
};

export default TestingCenterRunsPage;
